<template>
  <v-card class="elevation-0">
    <!-- Toolbar -->
    <v-toolbar flat dense color="grey lighten-4">
      <v-toolbar-title class="subtitle-1 font-weight-regular">
        {{ $t("pageHeader.users") }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        v-if="!hideCreate"
        color="primary"
        dark
        small
        fab
        :to="{ path: 'invite' }"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- Search -->
    <v-card-title>
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            v-model="search"
            :append-icon="search ? 'mdi-close' : 'mdi-magnify'"
            @click:append="search = ''"
            label="Search"
            dense
            outlined
            clearable
          />
        </v-col>
      </v-row>
    </v-card-title>

    <!-- Table -->
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="users"
        :options.sync="pagination"
        :server-items-length="count"
        :loading="loading"
        :items-per-page="pagination.rowsPerPage"
        class="elevation-1"
      >
        <template v-slot:item.firstName="{ item }">
          {{ item.firstName }}
        </template>

        <template v-slot:item.lastName="{ item }">
          {{ item.lastName || "N/A" }}
        </template>

        <template v-slot:item.phoneNumber="{ item }">
          {{ item.phoneNumber || "N/A" }}
        </template>

        <template v-slot:item.email="{ item }">
          {{ item.email || "N/A" }}
        </template>

        <template v-slot:item.action="{ item }">
          <v-menu bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                v-if="currentUser.id === item.id"
                @click="edituser(item)"
              >
                <v-list-item-title>{{ $t("buttons.edit") }}</v-list-item-title>
              </v-list-item>
              <v-list-item disabled @click="deleteuser(item)">
                <v-list-item-title>{{
                  $t("buttons.delete")
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import userService from "../service";

export default {
  name: "user-list",
  props: ["hideCreate"],
  data() {
    return {
      headers: [
        {
          text: this.$t("labels.firstName"),
          value: "firstName",
          sortable: true,
        },
        { text: this.$t("labels.lastName"), value: "lastName", sortable: true },
        {
          text: this.$t("labels.phoneNumber"),
          value: "phoneNumber",
          sortable: false,
        },
        {
          text: this.$t("labels.emailAddress"),
          value: "email",
          sortable: false,
        },
        { text: "", value: "action", sortable: false },
      ],
      search: null,
      users: [],
      count: 0,
      loading: false,
      pagination: {
        page: 1,
        rowsPerPage: 10,
        sortBy: "firstName",
        descending: false,
      },
    };
  },
  created() {
    this.getList();
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
  },
  watch: {
    search() {
      if (this.search?.length > 3 || this.search?.length === 0) {
        this.getList();
      }
    },
    pagination: {
      handler() {
        this.getList();
      },
      deep: true,
    },
  },
  methods: {
    async getList() {
      this.loading = true;
      const { page, rowsPerPage, sortBy, descending } = this.pagination;
      const offset = rowsPerPage * (page - 1);

      try {
        const response = await userService.getAll({
          limit: rowsPerPage,
          offset,
          search: this.search,
          orderBy: [sortBy, descending],
        });
        this.users = response.data;
        this.count = response.count;
      } finally {
        this.loading = false;
      }
    },
    edituser(user) {
      this.$router.push({ name: "user-edit", params: user });
    },
    deleteuser(user) {
      this.$swal({
        title: this.$t("messages.title.areYouSure"),
        text: this.$t("messages.text.youWontBeAbleToRevert"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: this.$t("buttons.cancel"),
        confirmButtonText: this.$t("buttons.yesDeleteIt"),
      }).then((result) => {
        if (result.value) {
          userService.delete(user.id).then((response) => {
            if (response.data) {
              this.$swal(
                this.$t("messages.title.deleted"),
                this.$t("messages.text.userHasDelete"),
                "success"
              );
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>